import type { ApmBase, TransactionOptions } from "@elastic/apm-rum";
export type * from "@elastic/apm-rum";

export interface StartTransactionOpts extends TransactionOptions {
  type?: string;
  additionalLabels?: Parameters<ApmBase["addLabels"]>[0];
}

const apm = typeof window === "undefined" ? null : window.elasticApm;

export const createTransaction = (name?: string, { type, additionalLabels, ...opts }: StartTransactionOpts = {}) => {
  if (!apm) return;

  const transaction = apm?.startTransaction(name, type, opts);
  transaction?.addLabels({
    ...additionalLabels,
    "service.name": window.__seo_metadata_initial_state__.name,
  });

  return transaction;
};

export const captureError = (error: unknown) => {
  if (apm && (error instanceof Error || typeof error === "string")) {
    apm.captureError(error);
  } else {
    console.error(error);
  }
};
